import React from 'react';
import { Route, Routes, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCommentDots, faDonate, faBriefcase, faUser } from '@fortawesome/free-solid-svg-icons';
import ImageToPdf from './components/ImageToPdf'; 
import PdfToImage from './components/PdfToImage'; 
import WordToPdf from './components/WordToPdf'; 
import HtmlToPdf from './components/HtmlToPdf'; 
import './App.css';

function App() {
  return (
    <div className="App">
      <Helmet>
        <title>File Converter</title>
        <meta name="description" content="Convert images to PDF, PDF to JPG/PNG, and Word to PDF easily." />
        <meta name="keywords" content="file converter, image to pdf, pdf to jpg, pdf to png, word to pdf" />
        <meta name="author" content="Krishnamohan Yagneswaran" />
        <link rel="canonical" href="https://your-site-url.com/" />
      </Helmet>
      <header className="App-header">
        <h1 className="animated-name">Krishnamohan Yagneswaran</h1>
        <div className="transition-text">
          <span>Solo Game Dev</span>
          <span>Web Developer</span>
          <span>Software Developer</span>
          <span>Game Tester</span>
        </div>
        <nav>
          <ul>
            <li><Link to="/"><FontAwesomeIcon icon={faHome} className="nav-icon" /> Home</Link></li>
            <li><a href="https://forms.gle/KZuz5nmDn1k4Yjx46"><FontAwesomeIcon icon={faCommentDots} className="nav-icon" /> Support</a></li>
            <li><a href="https://www.gadgetinsiderz.com/donation"><FontAwesomeIcon icon={faDonate} className="nav-icon" /> Donate</a></li>
            <li><a href="https://www.gadgetinsiderz.com/services-5"><FontAwesomeIcon icon={faBriefcase} className="nav-icon" /> Freelance</a></li>
            <li><a href="https://www.gadgetinsiderz.com/about"><FontAwesomeIcon icon={faUser} className="nav-icon" /> Portfolio</a></li>
          </ul>
        </nav>
      </header>
      <div className="center-box">
        <h2>Convert Your Files</h2>
        <ul>
          <li><Link to="/image-to-pdf">Convert Image to PDF</Link></li>
          <li><Link to="/pdf-to-image">Convert PDF to Image</Link></li>
          <li><Link to="/word-to-pdf">Convert Word to PDF</Link></li>
          <li><Link to="/html-to-pdf">Convert HTML to PDF</Link></li>
        </ul>
      </div>
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/image-to-pdf" element={<ImageToPdf />} />
          <Route path="/pdf-to-image" element={<PdfToImage />} />
          <Route path="/word-to-pdf" element={<WordToPdf />} />
          <Route path="/html-to-pdf" element={<HtmlToPdf />} />
        </Routes>
      </main>
      <footer>
        <p>© 2024 Krishnamohan Yagneswaran. All rights reserved.</p>
      </footer>
    </div>
  );
}

function Home() {
  return <div>Welcome to the File Converter App. Choose a tool from the center box above.</div>;
}

export default App;
